// extracted by mini-css-extract-plugin
export default {"BottomActions":"Home_BottomActions__cdMt1"};